import { generatePath } from "react-router-dom";
import {
  COPY_DESTINATION,
  DESTINATIONS,
  DESTINATION_ATTACH_TO_TEMPLATE,
  DESTINATION_BY_ID,
  DESTINATION_TEST,
} from "../apiEndPoints";
import { api, convertKeysToCamelCase, convertKeysToSnakeCase } from "./api";

export const destinationApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    createDestination: builder.mutation({
      query: ({ accountId, ...rest }) => ({
        url: generatePath(DESTINATIONS, { accountId }),
        method: "POST",
        body: convertKeysToSnakeCase(rest),
      }),
      invalidatesTags: ["Destinations"],
    }),
    getDestinations: builder.query({
      query: ({ accountId, offset, limit, includeTotalCount, search }) => {
        const baseUrl = generatePath(DESTINATIONS, { accountId });
        const queryParams = new URLSearchParams({
          offset: String(offset),
          limit: String(limit),
          include_total_count: String(includeTotalCount),
        });
        if (search) {
          queryParams.append("search", search);
        }
        return {
          url: `${baseUrl}?${queryParams.toString()}`,
          method: "GET",
        };
      },
      transformResponse: (response) => convertKeysToCamelCase(response),
      providesTags: (result, error, { accountId }) => [
        { type: "Destinations", id: accountId },
      ],
    }),
    getDestination: builder.query({
      query: ({ accountId, destinationId }) => ({
        url: generatePath(DESTINATION_BY_ID, { accountId, destinationId }),
        method: "GET",
      }),
      transformResponse: (response) => convertKeysToCamelCase(response),
      providesTags: (result, error, { accountId }) => [
        { type: "Destinations", id: accountId },
      ],
    }),
    updateDestination: builder.mutation({
      query: ({ accountId, destinationId, ...rest }) => ({
        url: generatePath(DESTINATION_BY_ID, { accountId, destinationId }),
        method: "PATCH",
        body: convertKeysToSnakeCase(rest),
      }),
      invalidatesTags: ["Destinations"],
    }),
    deleteDestination: builder.mutation({
      query: ({ accountId, destinationId }) => ({
        url: generatePath(DESTINATION_BY_ID, { accountId, destinationId }),
        method: "DELETE",
      }),
      invalidatesTags: ["Destinations"],
    }),
    testDestination: builder.mutation({
      query: ({ accountId, ...rest }) => ({
        url: generatePath(DESTINATION_TEST, { accountId }),
        method: "POST",
        body: convertKeysToSnakeCase(rest),
      }),
    }),
    attachDestinationToTemplate: builder.mutation({
      query: ({ accountId, destinationId, templateId }) => ({
        url: generatePath(DESTINATION_ATTACH_TO_TEMPLATE, {
          accountId,
          destinationId,
          templateId,
        }),
        method: "POST",
      }),
    }),
    removeDestinationFromTemplate: builder.mutation({
      query: ({ accountId, destinationId, templateId }) => ({
        url: generatePath(DESTINATION_ATTACH_TO_TEMPLATE, {
          accountId,
          destinationId,
          templateId,
        }),
        method: "DELETE",
      }),
    }),
    copyDestination: builder.mutation({
      query: ({ accountId, destinationId }) => ({
        url: generatePath(COPY_DESTINATION, { accountId, destinationId }),
        method: "POST",
      }),
      invalidatesTags: ["Destinations"],
    }),
  }),
});

export const {
  useCreateDestinationMutation,
  useGetDestinationsQuery,
  useGetDestinationQuery,
  useUpdateDestinationMutation,
  useDeleteDestinationMutation,
  useTestDestinationMutation,
  useAttachDestinationToTemplateMutation,
  useRemoveDestinationFromTemplateMutation,
  useCopyDestinationMutation,
} = destinationApiSlice;
